export default function ProSkill({ skill, index }){
    return (
        <div className="row">
            <div className="col-5 text-uppercase">
                <h6>{skill.title}</h6>
            </div>
            <div className="col-7">
                <div className="progress rounded-0 bar-container">
                    <div id={skill.title}
                        className="progress-bar bar-custom"
                        style={{ width: `${skill.value}%` }}
                        role="progressbar"
                        data-aos="fade-right"
                        data-aos-anchor=".aos-skills"
                        data-aos-delay={`${index * 100}`}
                        aria-valuenow={skill.value}
                        aria-valuemin="0"
                        aria-valuemax="100">
                    </div>
                </div>
            </div>
        </div>
    )
}